module.exports = __webpack_public_path__ + "media/Snake.658fbf23.ogg";